module.exports = __webpack_public_path__ + "img/icon-school5.8998596e.png";